import { useDispatch } from 'react-redux';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import type { TradeInSlideoutTab } from '@makemydeal/dr-dash-store/types/types';

export const useTradeEditModal = () => {
    const dispatch = useDispatch();

    const openTradeModal = (tab: TradeInSlideoutTab = 'trade-in') => {
        dispatch(baseDealActionCreators.setTradeInSlideoutTab(tab));
        if (tab !== 'prior-balance') {
            dispatch(interactionAnalyticsActionCreators.tradeInEditButton());
        }
        dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.TradeIn));
    };

    return { openTradeModal };
};
